var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSelectTemplate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.5L1 0.5C0.723849 0.5 0.5 0.723856 0.5 1L0.5 19C0.5 19.2762 0.723843 19.5 1 19.5L17 19.5C17.2761 19.5 17.5 19.2762 17.5 19L17.5 1C17.5 0.723862 17.2761 0.5 17 0.5ZM16.5 18.5L1.5 18.5L1.5 1.5L16.5 1.5L16.5 18.5ZM4.5 14.5V15.5L13.5 15.5V14.5L4.5 14.5ZM4.5 10.5V11.5L13.5 11.5V10.5L4.5 10.5ZM10.5 4.5L10.5 7.5L13.5 7.5L13.5 4.5L10.5 4.5ZM4.5 5.5V6.5H7.5V5.5H4.5Z",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSelectTemplate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/selectTemplate.ec38f1e0.svg";
export { ForwardRef as ReactComponent };